import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-lock-overturning-icon',
  templateUrl: './code-lock-overturning.component.html'
})
export class CodeLockOverturningComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
